module.exports = __webpack_public_path__ + "assets/img/TMSP2-2.725ab081.jpg";